<ng-container *ngIf="maintenance">
  <maintenance></maintenance>
</ng-container>

<div [style.display]="maintenance ? 'none' : 'block'">
<nb-layout withScroll="false" class="layoutcolumn">
	<nb-layout-header class="fix-header">
		<def-header *ngIf="currentUser" style="width:100%;" [currentUser]="currentUser" [reset]="reset">
		</def-header>
	</nb-layout-header>
	<nb-sidebar tag="left" *ngIf="sideBarVisible">
		<def-side-menu></def-side-menu>
	</nb-sidebar>
	<nb-layout-column class="layoutcolumn">
		<router-outlet></router-outlet>
		<def-services-health-check  *ngIf="loggedIn | async"></def-services-health-check>
		<def-report-issues></def-report-issues>
	</nb-layout-column>
	<nb-layout-footer>
		<def-footer></def-footer>
	</nb-layout-footer>
</nb-layout>
</div>
